var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('div',{staticClass:"scroll-pt w-full mb-48",class:_vm.isMedia(_vm.next) ? 'md-mb-72' : 'md-mb-60',attrs:{"id":_vm.id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }